<template>
  <v-card
    :loading="loading || defLoading"
    flat
    min-height="300"
    style="overscroll-behavior: contain; z-index: 5"
  >
    <custom-tabs v-model="tabs" :tab-items="tabItems" grow>
      <template v-slot:staticItems>
        <v-tab-item>
          <together-ai-image @saved="gotoSaved" />
        </v-tab-item>
        <v-tab-item>
          <v-row class="pa-2">
            <v-col
              class="d-flex align-items-center justify-content-center"
              cols="12"
              md="6"
            >
              <v-combobox
                :loading="loading"
                v-model="selectCategory"
                :items="category"
                label="انتخاب دسته بندی"
                outlined
                dense
              ></v-combobox>
            </v-col>
            <v-col
              cols="12"
              class="d-flex align-items-center justify-content-center"
              md="6"
            >
              <v-btn-toggle v-model="toggle_exclusive">
                <v-btn>
                  <v-icon>mdi-view-agenda</v-icon>
                </v-btn>
                <v-btn>
                  <v-icon>mdi-view-grid</v-icon>
                </v-btn>
                <v-btn>
                  <v-icon>mdi-view-module</v-icon>
                </v-btn>

                <v-btn>
                  <v-icon>mdi-view-comfy</v-icon>
                </v-btn>

                <v-btn>
                  <v-icon>mdi-view-grid-compact</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
          <v-row
            class="pa-3 custom-scrollbar"
            no-gutters
            style="max-height: calc(90vh - 300px); overflow-y: auto"
          >
            <v-col
              v-for="image in img.items.data"
              :key="image.id"
              :data-img="image.id"
              class="pa-1"
              :cols="resp.cols"
              :md="resp.md"
            >
              <v-img
                :key="image.id"
                :aspect-ratio="16 / 9"
                :lazy-src="image.full_path"
                :src="image.full_path"
                class="rounded"
              >
                <div class="pa-2 w-100">
                  <v-btn
                    :loading="upLoading"
                    class="btn-accept rounded-lg ma-0"
                    depressed
                    @click="downloadImage({ link: image.full_path })"
                  >
                    <v-icon left>mdi-cloud-download</v-icon>
                    دانلود تصویر
                  </v-btn>
                </div>
              </v-img>
            </v-col>

            <v-col cols="12">
              <v-card
                v-if="!loading && !isLastPage && tabs === 1 && !getError"
                v-intersect="onIntersect"
              >
                <v-progress-circular
                  color="primary"
                  indeterminate
                  size="35"
                  width="5"
                />
              </v-card>
            </v-col>
          </v-row>

          <v-card
            v-if="!loading && (!img.items.data || !img.items.data.length)"
            flat
            style="max-height: calc(90vh - 250px); overflow-y: auto"
            width="100%"
          >
            <v-card-title
              class="text-center justify-center"
              v-text="'تصویری پیدا نشد!'"
            />
            <v-card-subtitle
              class="text-center"
              v-text="
                'برای افزودن فایل از فیلد بازگذاری تصاویر یا آپلود سنتر استفاده نمایید'
              "
            />
          </v-card>
        </v-tab-item>
      </template>
    </custom-tabs>
    <!-- <v-tabs v-model="tabs" color="primary">
      <v-tab>
        <v-icon right>mdi-image-auto-adjust</v-icon>
        خلق تصویر
      </v-tab>

      <v-tab @click="getImages">
        <v-icon right>mdi-image-area-close</v-icon>
        گالری تصاویر
      </v-tab>
    </v-tabs> -->

    <v-divider class="mt-0" />

    <!-- <v-tabs-items v-model="tabs">
      <v-tab-item>
        <together-ai-image @saved="gotoSaved" />
      </v-tab-item>

      <v-tab-item>
        <v-row
          class="pa-3 custom-scrollbar"
          no-gutters
          style="max-height: calc(90vh - 300px); overflow-y: auto"
        >
          <v-col
            v-for="image in img.items.data"
            :key="image.id"
            :data-img="image.id"
            class="pa-1"
            cols="12"
            md="4"
          >
            <v-img
              :key="image.id"
              :aspect-ratio="16 / 9"
              :lazy-src="image.full_path"
              :src="image.full_path"
              class="rounded"
            >
              <div class="pa-2 w-100">
                <v-btn
                  :loading="upLoading"
                  class="btn-accept rounded-lg ma-0"
                  depressed
                  @click="downloadImage({ link: image.full_path })"
                >
                  <v-icon left>mdi-cloud-download</v-icon>
                  دانلود تصویر
                </v-btn>
              </div>
            </v-img>
          </v-col>

          <v-col cols="12">
            <v-card
              v-if="!loading && !isLastPage && tabs === 1 && !getError"
              v-intersect="onIntersect"
            >
              <v-progress-circular
                color="primary"
                indeterminate
                size="35"
                width="5"
              />
            </v-card>
          </v-col>
        </v-row>

        <v-card
          v-if="!loading && (!img.items.data || !img.items.data.length)"
          flat
          style="max-height: calc(90vh - 250px); overflow-y: auto"
          width="100%"
        >
          <v-card-title
            class="text-center justify-center"
            v-text="'تصویری پیدا نشد!'"
          />
          <v-card-subtitle
            class="text-center"
            v-text="
              'برای افزودن فایل از فیلد بازگذاری تصاویر یا آپلود سنتر استفاده نمایید'
            "
          />
        </v-card>
      </v-tab-item>
    </v-tabs-items> -->
  </v-card>
</template>

<script>
import { rbAxios } from "@/main";
import TogetherAiImage from "@/components/image/togetherAiImage.vue";

export default {
  name: "picSelector",

  components: { TogetherAiImage },

  data() {
    return {
      upLoading: false,
      loading: false,
      defLoading: false,
      category: [],
      selectCategory: "تصاویر خلق شده",
      tabs: 0,
      img: {
        items: {},
      },
      toggle_exclusive: 2,
      resp: { cols: 4, md: 4 },
      isLastPage: false,
      page: 1,
      getError: false,
      tabItems: [
        { text: "خلق تصویر", icon: "image-auto-adjust", value: "create_image" },
        {
          text: "گالری تصاویر",
          icon: "image-area-close",
          value: "image_gallery",
        },
      ],
    };
  },

  watch: {
    selectCategory(val) {
      this.img.items.data = [];
      this.page = 1;
      this.getImages();
    },
    toggle_exclusive: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val);

        this.response(val);
      },
    },
  },
  mounted() {
    this.getImages();
    if (this.$vuetify.breakpoint.smAndDown) {
      this.toggle_exclusive = 0;
    }
  },

  methods: {
    async getImages() {
      this.loading = true;

      try {
        const { data } = await rbAxios.get(
          `${process.env.VUE_APP_ROBOT}/files`,
          {
            params: {
              paginate: 10,
              page: this.page,
              category: this.selectCategory,
              length: 5,
              dir: "desc",
            },
          }
        );
        this.category = data.data?.categories;
        const currentImages = this.img?.items?.data || [];

        // فیلتر تصاویر صفحه جدید
        const newImages = data.data.items.data || [];

        const allImages = [...currentImages, ...newImages];

        // مرتب‌سازی بر اساس created_at (جدیدترین اول)
        allImages.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );

        // ذخیره نهایی
        this.img.items.data = allImages;

        this.isLastPage = !data.data.items.next_page_url;
        this.page++;
      } catch ({ response }) {
        this.getError = true;
        console.error("❌ error in get images:", response);
      } finally {
        this.loading = false;
      }
    },
    downloadImage({ link }) {
      const links = document.createElement("a");
      links.href = link;
      links.download = `my_image_${Math.ceil(Math.random() * 2000)}.jpg`;
      document.body.appendChild(links);
      links.click();
      document.body.removeChild(links);
      this.$toast.success(`عکس شما با موفقیت دانلود شد`);
    },

    onIntersect(entries, observer) {
      this.isIntersecting = entries[0].isIntersecting;
      this.$nextTick(() => {
        if ((this.isIntersecting || !this.img.items.data) && !this.isLastPage)
          this.getImages();
      });
    },

    gotoSaved(cat) {
      this.loading = true;
      this.img.items.data = [];
      this.tabs = 1;
      this.page = 1;
      (this.selectCategory = "تصاویر خلق شده"), this.getImages();
    },

    response(val) {
      let responsecode = val + 1;
      switch (responsecode) {
        case 1:
          this.resp = { cols: 12, md: 12 };
          break;
        case 2:
          this.resp = { cols: 6, md: 6 };
          break;
        case 3:
          this.resp = { cols: 4, md: 4 };
          break;
        case 4:
          this.resp = { cols: 3, md: 3 };
          break;
        case 5:
          this.resp = { cols: 2, md: 2 };
          break;
      }
    },
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

@media screen and (max-width: 600px) {
  .v-tabs >>> .v-slide-group__prev {
    display: none !important;
  }
}
</style>
